import { render, staticRenderFns } from "./AuthorizationNeeded.vue?vue&type=template&id=28595f60"
import script from "./AuthorizationNeeded.vue?vue&type=script&lang=js"
export * from "./AuthorizationNeeded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports